module.exports = __webpack_public_path__ + "static/media/soap-2.a7588e36.jpg";